import React, { useState } from 'react';
import { Settings, Bell, Smartphone, Key } from 'lucide-react';
import NotificationsManager from './NotificationsManager';
import VersionManager from './VersionManager';
import APIKeysManager from './APIKeysManager';

type SettingsTab = 'notifications' | 'version' | 'api-keys';

const SettingsManager: React.FC = () => {
  const [activeTab, setActiveTab] = useState<SettingsTab>('notifications');

  return (
    <div>
      <div style={{ marginBottom: '2rem' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.5rem' }}>
          <Settings size={28} style={{ color: '#3b82f6' }} />
          <h2 style={{ margin: 0 }}>Settings</h2>
        </div>
        <p style={{ color: '#6b7280', marginTop: '0.5rem' }}>
          Manage app settings, notifications, version control, and API keys.
        </p>
      </div>

      {/* Settings Tabs */}
      <div style={{
        display: 'flex',
        gap: '0.5rem',
        borderBottom: '2px solid #e5e7eb',
        marginBottom: '2rem'
      }}>
        <button
          onClick={() => setActiveTab('notifications')}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: '0.75rem 1.5rem',
            background: activeTab === 'notifications' ? '#3b82f6' : 'transparent',
            color: activeTab === 'notifications' ? 'white' : '#6b7280',
            border: 'none',
            borderRadius: '8px 8px 0 0',
            cursor: 'pointer',
            fontWeight: activeTab === 'notifications' ? '600' : '500',
            fontSize: '0.95rem',
            transition: 'all 0.2s',
            transform: activeTab === 'notifications' ? 'translateY(2px)' : 'none'
          }}
          onMouseEnter={(e) => {
            if (activeTab !== 'notifications') e.currentTarget.style.background = '#f3f4f6';
          }}
          onMouseLeave={(e) => {
            if (activeTab !== 'notifications') e.currentTarget.style.background = 'transparent';
          }}
        >
          <Bell size={18} />
          Notifications
        </button>

        <button
          onClick={() => setActiveTab('version')}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: '0.75rem 1.5rem',
            background: activeTab === 'version' ? '#3b82f6' : 'transparent',
            color: activeTab === 'version' ? 'white' : '#6b7280',
            border: 'none',
            borderRadius: '8px 8px 0 0',
            cursor: 'pointer',
            fontWeight: activeTab === 'version' ? '600' : '500',
            fontSize: '0.95rem',
            transition: 'all 0.2s',
            transform: activeTab === 'version' ? 'translateY(2px)' : 'none'
          }}
          onMouseEnter={(e) => {
            if (activeTab !== 'version') e.currentTarget.style.background = '#f3f4f6';
          }}
          onMouseLeave={(e) => {
            if (activeTab !== 'version') e.currentTarget.style.background = 'transparent';
          }}
        >
          <Smartphone size={18} />
          Version Control
        </button>

        <button
          onClick={() => setActiveTab('api-keys')}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: '0.75rem 1.5rem',
            background: activeTab === 'api-keys' ? '#3b82f6' : 'transparent',
            color: activeTab === 'api-keys' ? 'white' : '#6b7280',
            border: 'none',
            borderRadius: '8px 8px 0 0',
            cursor: 'pointer',
            fontWeight: activeTab === 'api-keys' ? '600' : '500',
            fontSize: '0.95rem',
            transition: 'all 0.2s',
            transform: activeTab === 'api-keys' ? 'translateY(2px)' : 'none'
          }}
          onMouseEnter={(e) => {
            if (activeTab !== 'api-keys') e.currentTarget.style.background = '#f3f4f6';
          }}
          onMouseLeave={(e) => {
            if (activeTab !== 'api-keys') e.currentTarget.style.background = 'transparent';
          }}
        >
          <Key size={18} />
          API Keys
        </button>
      </div>

      {/* Tab Content */}
      <div>
        {activeTab === 'notifications' && <NotificationsManager />}
        {activeTab === 'version' && <VersionManager />}
        {activeTab === 'api-keys' && <APIKeysManager />}
      </div>
    </div>
  );
};

export default SettingsManager;
